module.exports = __webpack_public_path__ + "static/media/global-intro--resized.f781d28a.jpg";